import { DEV_SCENARIO_COOKIE_NAME, type DevScenario, devScenarioNames } from '@arya/shared/domain';

export interface ScenarioConsoleHost {
  cookie: string;
  readonly location: Pick<Location, 'reload'>;
}

export interface ScenarioConsole {
  readonly list: () => DevScenario[];
  readonly use: (...names: string[]) => void;
  readonly active: () => string[];
  readonly clear: () => void;
}

export const scenarioConsole = (host: ScenarioConsoleHost, scenarios: readonly DevScenario[]): ScenarioConsole => {
  const known = new Set(scenarios.map(({ name }) => name));
  const writeAndReload = (cookie: string): void => {
    host.cookie = cookie;
    host.location.reload();
  };
  return {
    list: () => scenarios.map((scenario) => ({ ...scenario })),
    use: (...names) => {
      if (names.length === 0 || names.some((name) => !known.has(name))) {
        throw new Error(`Use one or more of ${[...known].join(', ')}; got ${names.join(', ') || 'nothing'}.`);
      }
      writeAndReload(`${DEV_SCENARIO_COOKIE_NAME}=${names.join(',')}; path=/`);
    },
    active: () => devScenarioNames(host.cookie),
    clear: () => writeAndReload(`${DEV_SCENARIO_COOKIE_NAME}=; path=/; max-age=0`),
  };
};
